import React, { useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';

const MultiSelect = props => {
    let inputClassName = props.inputClassName ? "cdx-input " + props.inputClassName : "cdx-input";
    const [value, setValue] = React.useState([]);
    const [options, setOptions] = React.useState(props.options || []);
    const [maxSelections, setMaxSelections] = React.useState(props.maxSelections || 0);

    useEffect(() => {
        setValue(props.value || []);
        setOptions(props.options || []);
    }, [props.options]);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);


    const handleSelection = (item) => {
        let newValue = [...value];
        let isSelected = value.filter(x => x.value === item.value).length > 0 ? true : false;
        if (isSelected) {
            newValue = newValue.filter(x => x.value !== item.value);
        } else {
            newValue = newValue.concat(item);
        }

        setValue(newValue);
        props.onChange(newValue);

        // console.log('newValue', newValue);
    };

    const handleToogle = () => {
        setValue(props.value);
    };

    return (
        <div className='cdx-multi-select'>
            <Dropdown autoClose="outside" onToggle={handleToogle}>
                <Dropdown.Toggle id="dropdown-basic" className={inputClassName} as="div">
                    {value.length > 0 ? value.length + " selected" : "Select"}
                </Dropdown.Toggle>
                <Dropdown.Menu className='multi-select'>
                    {options.map((item, index) => {
                        let isSelected = value.filter(x => x.value === item.value).length > 0 ? true : false;

                        return (
                            <Dropdown.Item
                                key={'multi-' + index}
                                onClick={() => handleSelection(item)}
                                className={isSelected ? "selected-item" : ''}
                                disabled={value.length >= maxSelections && !maxSelections == 0 && !isSelected}
                            >
                                <input type="checkbox" checked={isSelected} onChange={() => handleSelection(item)} />
                                {item.label}
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default MultiSelect;